import React from 'react'
import { Helmet } from 'react-helmet'
import PageWrapper from '../../components/PageWrapper'
import PageContentWrapper from '../../components/PageWrapper/PageContentWrapper'
import Headings from '../../components/Headings'
import PageFooter from '../../components/PageFooter'
import { consentFooterData } from '../../data/footerData'
import DirectionLink from '../../components/DirectionLink'

const DataDeletion = ({ onCloseFunc, isDisplay }) => {
  return (
    <PageWrapper isDisplay={isDisplay}>
      <Helmet>
        <title>Data deletion</title>
      </Helmet>
      <PageContentWrapper>
        <DirectionLink
          direction="cross"
          onCloseFunc={onCloseFunc}
          text="Close"
          isDepenednt={true}
          isFocused={true}
          setFocus={isDisplay}
          description="Close button, to visit previous page double click here."
        ></DirectionLink>
        <Headings level="h1" text="Data deletion"></Headings>
        <p>You can choose for us to delete data that we no longer need.</p>
        <Headings level="h2" text="When will we delete your data?"></Headings>
        <p>We'll remove the data you have provided when:</p>
        <ul>
          <li>we no longer need it to provide you with this service, or</li>
          <li>you no longer allow us to collect and use your data.</li>
        </ul>
        <p>
          We may need to keep your data for 1 year for business and legal
          purposes. Reasons we might retain some data include:{' '}
        </p>
        <ul>
          <li>Security, fraud {'&'} abuse prevention,</li>
          <li>Financial record-keeping, and/or</li>
          <li>Complying with legal or regulatory requirements.</li>
        </ul>
        <Headings level="h2" text="How will we delete your data?"></Headings>
        <p>We'll delete your data by removing it from our systems.</p>
      </PageContentWrapper>
      <PageFooter {...consentFooterData} />
    </PageWrapper>
  )
}
export default DataDeletion
